import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  CircularProgress,
  Alert,
  Button,
  Stack
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import loyaltyService from '../../services/loyaltyService';
import LoyaltyCard from './LoyaltyCard';

function Dashboard() {
  const { user, org } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loyaltyCards, setLoyaltyCards] = useState([]);

  useEffect(() => {
    // If org is set, redirect directly to the membership details
    if (org && typeof org === 'object' && org.id) {
      navigate(`/memberships/${org.id}`);
    }
  }, [org, navigate]);

  useEffect(() => {
    const fetchLoyaltyCards = async () => {
      try {
        const data = await loyaltyService.getUserPoints();
        setLoyaltyCards(data.groups || []);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching loyalty cards:', err);
        setError('Failed to load loyalty cards. Please try again later.');
        setLoading(false);
      }
    };

    fetchLoyaltyCards();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome, {user?.first_name}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          View your loyalty programs and reward coins.
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : loyaltyCards.length === 0 ? (
        <Stack sx={{ p: 4 }} justifyContent="center" alignItems="center" gap={5}>
          <Typography variant="h6" gutterBottom>
            No Loyalty Programs Yet
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You haven't joined any loyalty programs. Start earning rewards today!
          </Typography>
          <Button
            component={Link}
            to="/locations"
            variant="contained"
            color="primary"
            size="large"
          >
            Discover Locations
          </Button>
        </Stack>
      ) : (
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          {loyaltyCards.map((card) => (
            <Grid item key={card.id}>
              <LoyaltyCard group={card} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
}

export default Dashboard;